module.exports = __webpack_public_path__ + "img/tianjia2.65dd3481.png";